import { defineStore } from 'pinia';
import { strapi } from '~/stores/transport/strapi';
import { assignDataToFields, createPopulateString } from '~/utils/strapiComponents/addStrapiData';
import type { TCurrencyAlertData } from '~/types/deposit';

export const useStoreWithdrawModal = defineStore('withdrawModal', {
  state: () => ({
    title: '',
    lockedByBonusText: '',
    withdrawableBalanceText: '',
    infoTextAddress: '',
    bankAccountFirstName: '',
    bankAccountLastName: '',
    titleVerificationBannerProfile: '',
    textLinkVerificationBannerProfile: '',
    textVerificationBannerProfile: '',
    linkVerificationBannerProfile: '',
    bankAccountId: '',
    bankCode: '',
    successMessageText: '',
    errorNotEnoughMoneyText: '',
    currencyAlert: [] as TCurrencyAlertData[],
    locale: '',
    requestPromise: null as Promise<any> | null,
  }),

  actions: {
    async loadWithdrawModal() {
      if (!this.requestPromise) {
        const populateString = createPopulateString(['currencyAlert']);

        this.requestPromise = strapi()
          .get('withdraw-modal', populateString)
          .finally(() => (this.requestPromise = null));
      }

      const response = await this.requestPromise;

      if (response?.data) {
        assignDataToFields(this, response.data);

        return true;
      } else {
        return false;
      }
    },
  },
});
